import type { ApiListRequest, ApiListResponse } from "../@types/services/Api";
import type { User, UserFilters } from "../@types/services/User";
import { api } from "./api";

const API_BASE_URL = "/api/v2/users";

export const fetchUsers = async ({
  filters,
  ...rest
}: ApiListRequest<UserFilters> = {}): Promise<ApiListResponse<User>> => {
  const response = await api.get<ApiListResponse<User>>("", {
    baseURL: API_BASE_URL,
    params: {
      ...filters,
      ...rest,
    },
  });

  return response.data;
};

export const fetchUser = async (userId: number): Promise<User> => {
  const response = await api.get<User>(`/${userId}`, {
    baseURL: API_BASE_URL,
  });

  return response.data;
};

export const checkMandatoryTerms = async (
  userId: number,
): Promise<{
  missing_terms: boolean;
}> => {
  const response = await api.get<{ missing_terms: boolean }>(
    `/${userId}/check_terms`,
    {
      baseURL: API_BASE_URL,
    },
  );

  return response.data;
};

export const updateUser = async (
  userId: number,
  data: { user: Partial<User> },
): Promise<User> => {
  const response = await api.put<User>(`/${userId}`, data, {
    baseURL: API_BASE_URL,
  });

  return response.data;
};
